import { Col, Row } from "reactstrap";

const Card = ({ heading, content, image }) => {
  return (
    <Row className="g-0 align-items-center row-gap-2">
      <Col lg={8} className="pe-lg-2">
        <div className="fw-semibold">{heading}</div>
        <ul className="m-0">
          <li>{content}</li>
        </ul>
      </Col>
      <Col lg={4} className="d-flex justify-content-end">
        <img src={image || ""} alt="Maelano" width={185} height={111} className="img-fluid" />
      </Col>
    </Row>
  );
};

export default Card;